// This function will strip all anchors from the original code
export const removeAnchorsFromCode = (
  code: string,
  anchors: string[],
): string => {
  const lines: string[] = code.split(/\r?\n/);

  const cleanedLines = lines.map(line => {
    if (
      anchors.some(anchor => line.match(`(${anchor})([^a-zA-Z\\S]|$|-->$)`))
    ) {
      return false;
    }
    return line;
  });

  return cleanedLines.filter(l => l !== false).join('\n');
};
